import { useEffect, useRef } from 'react';

import * as Sentry from '@sentry/react';

import { useAssociateStableId } from '@m/hooks/data/experiments';
import { getStableId } from '@m/utils/stableId';

export function useStableIdAssociation({
  authenticated,
  userId,
}: {
  authenticated: boolean | null;
  userId?: number;
}) {
  const { mutate: associateStableId } = useAssociateStableId();
  const associatedKeyRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!authenticated || userId === undefined) {
      return;
    }

    const stableId = getStableId();
    if (!stableId) {
      return;
    }

    const associationKey = `${userId}:${stableId}`;
    if (associatedKeyRef.current === associationKey) {
      return;
    }
    associatedKeyRef.current = associationKey;

    associateStableId(stableId, {
      onError: (error) => {
        associatedKeyRef.current = undefined;
        Sentry.captureException(error);
      },
    });
  }, [associateStableId, authenticated, userId]);
}
